























import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import appconst from '@/lib/appconst';
import storeaddressInfo from '@/store/entities/back-storeaddress-list';
import Enums from '@/lib/enums'
class AddModel {
    id: number;
    storeId: number;
    productSku: string;
    productType: number;
    productName: string;
    purchaseCost: number;
    productImgGuid: string;
    productLink: string;
    productNums: number;
    remark: string;
    logisticsNumber: string;
    packageNums: number;
}
@Component
export default class QuickStockPackage extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    stock: AddModel = new AddModel();
   /* storeaddressList: Array<storeaddressInfo> = [];*/
    //siteType = Enums.SiteSType;
    //productTypeList = Enums.ProductType;
    addLoding = false;
    imgUrl: string = '';
    imgUploadUrl: string = '';
    async editedit() {
        this.addLoding = true;
        await this.$store.dispatch({
            type: 'frontstock/EditStock',
            data: this.stock
        }).finally(() => {
            this.addLoding = false;
        });
        (this.$refs.editForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);

    }

    setImage() {
        if (this.stock.productImgGuid && this.stock.productImgGuid.length > 1) {
            var data = { imageGuid: this.stock.productImgGuid, url: null };
            this.$store.commit('backlogistics/getImgUrl', data);
            this.imgUrl = data.url;
        } else {
            this.imgUrl = null;
        }
    }
    cancel() {
        (this.$refs.editForm as any).resetFields();
        this.$emit('input', false);
    }

    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
            var data = this.$store.state.frontstock.stockmodel;
            //this.$set(this.stock, "id", data.id);
            this.$set(this.stock, "storeId", data.storeId);
            this.$set(this.stock, "productSku", data.productSku);
            this.$set(this.stock, "productType", data.productType);
            this.$set(this.stock, "purchaseCost", data.purchaseCost);
            this.$set(this.stock, "productName", data.productName);
            this.$set(this.stock, "productImgGuid", data.productImgGuid);
            this.$set(this.stock, "productLink", data.productLink);
            this.$set(this.stock, "productNums", data.productNums);
            this.$set(this.stock, "remark", data.remark);
            this.setImage();
        }
    }

}
